import React from 'react';

const Gradient = ({ setBackColor }) => {

  return (
    <div className="main-bg-colors">
      <div style={{ marginRight: "0px" }}>

        <div onClick={() => setBackColor('linear-gradient(rgb(255, 255, 255) 0%, rgb(225, 230, 236) 100%)')}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 255, 255) 0%, rgb(225, 230, 236) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(216, 223, 227) 0%, rgb(174, 184, 189) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(216, 223, 227) 0%, rgb(174, 184, 189) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(42, 42, 42) 0%, rgb(0, 0, 0) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(42, 42, 42) 0%, rgb(0, 0, 0) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(255, 180, 61) 0%, rgb(255, 142, 61) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 180, 61) 0%, rgb(255, 142, 61) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(255, 230, 93) 0%, rgb(247, 195, 74) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 230, 93) 0%, rgb(247, 195, 74) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(203, 255, 90) 0%, rgb(129, 213, 69) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(203, 255, 90) 0%, rgb(129, 213, 69) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(81, 189, 73) 0%, rgb(55, 134, 49) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(81, 189, 73) 0%, rgb(55, 134, 49) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(115, 229, 220) 0%, rgb(52, 224, 210) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(115, 229, 220) 0%, rgb(52, 224, 210) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(96, 204, 255) 0%, rgb(0, 156, 255) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(96, 204, 255) 0%, rgb(0, 156, 255) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(0, 132, 255) 0%, rgb(13, 85, 185) 100%)")}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(0, 132, 255) 0%, rgb(13, 85, 185) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(29, 62, 89) 0%, rgb(11, 37, 61) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(29, 62, 89) 0%, rgb(11, 37, 61) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(91, 43, 127) 0%, rgb(45, 20, 64) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(91, 43, 127) 0%, rgb(45, 20, 64) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(126, 104, 223) 0%, rgb(83, 61, 178) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(126, 104, 223) 0%, rgb(83, 61, 178) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(162, 141, 255) 0%, rgb(121, 97, 230) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(162, 141, 255) 0%, rgb(121, 97, 230) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(243, 234, 255) 0%, rgb(219, 194, 255) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(243, 234, 255) 0%, rgb(219, 194, 255) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(255, 125, 164) 0%, rgb(246, 52, 111) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 125, 164) 0%, rgb(246, 52, 111) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(255, 101, 105) 0%, rgb(239, 58, 63) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 101, 105) 0%, rgb(239, 58, 63) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(246, 74, 34) 0%, rgb(199, 9, 15) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(246, 74, 34) 0%, rgb(199, 9, 15) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(82, 65, 57) 0%, rgb(51, 41, 36) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(82, 65, 57) 0%, rgb(51, 41, 36) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(165, 133, 87) 0%, rgb(128, 104, 70) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(165, 133, 87) 0%, rgb(128, 104, 70) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(229, 186, 125) 0%, rgb(191, 145, 80) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(229, 186, 125) 0%, rgb(191, 145, 80) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(255, 248, 238) 0%, rgb(245, 231, 211) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(255, 248, 238) 0%, rgb(245, 231, 211) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(169, 188, 198) 0%, rgb(108, 123, 131) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(169, 188, 198) 0%, rgb(108, 123, 131) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(4, 187, 198) 0%, rgb(144, 58, 243) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(4, 187, 198) 0%, rgb(144, 58, 243) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(68, 222, 255) 0%, rgb(41, 66, 255) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(68, 222, 255) 0%, rgb(41, 66, 255) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(68, 222, 255) 0%, rgb(33, 255, 126) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(68, 222, 255) 0%, rgb(33, 255, 126) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(245, 231, 211) 0%, rgb(255, 252, 84) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(245, 231, 211) 0%, rgb(255, 252, 84) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(237, 160, 91) 0%, rgb(197, 37, 25) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(237, 160, 91) 0%, rgb(197, 37, 25) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(234, 248, 235) 0%, rgb(139, 251, 249) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(234, 248, 235) 0%, rgb(139, 251, 249) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(226, 241, 251) 0%, rgb(238, 168, 175) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(226, 241, 251) 0%, rgb(238, 168, 175) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(38, 248, 253) 0%, rgb(195, 186, 248) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(38, 248, 253) 0%, rgb(195, 186, 248) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(183, 225, 232) 0%, rgb(255, 214, 245) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(183, 225, 232) 0%, rgb(255, 214, 245) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(238, 243, 245) 0%, rgb(249, 61, 95) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(238, 243, 245) 0%, rgb(249, 61, 95) 100%)",
          }}
        ></div>
        <div onClick={() => setBackColor("linear-gradient(rgb(81, 102, 199) 0%, rgb(30, 178, 205) 100%)"
        )}
          className="color-box"
          style={{
            background:
              "linear-gradient(rgb(81, 102, 199) 0%, rgb(30, 178, 205) 100%)",
          }}
        ></div>

      </div>

    </div>

  );
};


export default Gradient;